import { getBuilderAccountStatusApi } from "@/apis/builder/builderService";
import { useOnboardingStore } from "@/store/onboardingStore";
import { STORAGE_KEYS } from "@/utils/sessionStorageKeys";

const applyIncompleteOnboarding = () => {
  localStorage.removeItem(STORAGE_KEYS.USER_NAME);
  sessionStorage.removeItem(STORAGE_KEYS.LEGACY_USER_NAME);
  useOnboardingStore.getState().updateOnboardingProgress({
    kycCompleted: false,
    signatoryCompleted: false,
  });
};

export const refreshBuilderAccountStatus = async () => {
  try {
    const response = await getBuilderAccountStatusApi();
    const data = response?.responceDataObject?.data;

    if (!data) {
      applyIncompleteOnboarding();
      return null;
    }

    const userName = String(data.username || "").trim();
    if (userName) {
      localStorage.setItem(STORAGE_KEYS.USER_NAME, userName);
      sessionStorage.removeItem(STORAGE_KEYS.LEGACY_USER_NAME);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_NAME);
      sessionStorage.removeItem(STORAGE_KEYS.LEGACY_USER_NAME);
    }

    useOnboardingStore.getState().updateOnboardingProgress({
      kycCompleted: Boolean(data.kycUploadStatus),
      signatoryCompleted: Boolean(data.authorizedSignatoryStatus),
    });

    return data;
  } catch (error) {
    console.error("Failed to refresh builder account status:", error);
    applyIncompleteOnboarding();
    return null;
  }
};
